// extracted by mini-css-extract-plugin
module.exports = {"about__container":"About_about__container__1n36q"};